export default __webpack_public_path__ + "static/media/motyl.7520131e.svg";